import { toApiDate } from "../../utils/dateUtils";
export var transformFormToApiParams = function (data) {
    var params = {
        offset: parseInt(data.offset, 10) || 0,
        limit: parseInt(data.limit, 10) || 100,
    };
    if (data.modifiedSince) {
        var apiDate = toApiDate(data.modifiedSince);
        if (apiDate) {
            params.modifiedSince = "".concat(apiDate, "T00:00:00Z");
        }
    }
    if (data.modifiedBefore) {
        var apiDate = toApiDate(data.modifiedBefore);
        if (apiDate) {
            params.modifiedBefore = "".concat(apiDate, "T23:59:59Z");
        }
    }
    if (data.isbns && data.isbns.trim()) {
        params.isbns = data.isbns
            .split(/[,\n]/)
            .map(function (s) { return s.trim(); })
            .filter(function (s) { return s.length > 0; });
    }
    if (data.titleIds && data.titleIds.trim()) {
        params.titleIds = data.titleIds
            .split(/[,\n]/)
            .map(function (s) { return s.trim(); })
            .filter(function (s) { return s.length > 0; });
    }
    return params;
};
